import HolidaySettingsStore from "@/modules/setting/stores/holiday/holiday_settings.store";
import CompanyPositionStore from "./positions/company_position.store";

export default {
  modules: {
    HolidaySettingsStore,
    CompanyPositionStore,
  },
};
